module.exports = __webpack_public_path__ + "static/media/scroll02_1.b3d6262d.png";